import client from "directus/src/client";
import { customEndpoint } from "directus/src/operations";

export async function createKeka({ item }) {
  try {
    const response = await client.request(
      customEndpoint({
        path: "/integration/keka/connect",
        method: "POST",
        body: JSON.stringify(item),
      }),
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
